module.exports = __webpack_public_path__ + "static/media/cohere.469b83b7.jpg";